//
// landmass.ts — real coastlines. Build 2.0, item 3.
//
// Natural Earth land polygons (public domain), the same JSON the iOS app
// bundles as `landmass.json`. Coarse (110m) for the whole disc; fine (50m)
// once you zoom toward a coast. Unit Gleason points (centre 0, radius 1)
// are computed once so the render loop only scales and translates.
//
// Do not hand-edit the rings. The JSON is generated from Natural Earth.
//

import { project, type Point } from "./gleason";
import raw from "./landmass.json";

export interface MapLabel {
  text: string;
  lat: number;
  lon: number;
}

/** Switch to 50m once the disc is close enough that 110m would smear. */
export const FINE_ZOOM = 2.2;

const file = raw as { coarse: number[][][]; fine: number[][][] };

function toUnit(rings: number[][][]): Point[][] {
  return rings
    .map((ring) =>
      ring
        .filter((pair) => pair.length >= 2)
        .map(([lon, lat]) => project(lat, lon, 0, 0, 1)),
    )
    .filter((ring) => ring.length >= 3);
}

export const UNIT_COARSE = toUnit(file.coarse);
export const UNIT_FINE = toUnit(file.fine);

export function unitRings(zoom: number): Point[][] {
  return zoom >= FINE_ZOOM ? UNIT_FINE : UNIT_COARSE;
}

export const MAP_LABELS: MapLabel[] = [
  { text: "NORTH PACIFIC", lat: 25, lon: -160 },
  { text: "SOUTH PACIFIC", lat: -25, lon: -140 },
  { text: "NORTH ATLANTIC", lat: 30, lon: -40 },
  { text: "SOUTH ATLANTIC", lat: -20, lon: -20 },
  { text: "INDIAN OCEAN", lat: -20, lon: 80 },
  { text: "ARCTIC OCEAN", lat: 85, lon: 0 },
  { text: "NORTH AMERICA", lat: 48, lon: -100 },
  { text: "EUROPE", lat: 52, lon: 15 },
  { text: "ASIA", lat: 50, lon: 90 },
  { text: "AFRICA", lat: 10, lon: 20 },
  { text: "SOUTH AMERICA", lat: -15, lon: -60 },
  { text: "AUSTRALIA", lat: -25, lon: 135 },
  { text: "ANTARCTICA", lat: -78, lon: 0 },
];
